export default function FinalCta() {
  return (
    <section
      id="final-cta"
      className="lg:tw-py-20 tw-py-10 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-fintoo-orange tw-relative tw-overflow-hidden"
    >
      <div className="tw-max-w-4xl tw-mx-auto tw-px-6 tw-text-center tw-relative tw-z-10">
        <h2 className="tw-text-4xl lg:tw-text-5xl tw-font-bold tw-text-white tw-mb-6">
          Ready to Secure Your Family’s Future?
        </h2>
        <p className="tw-text-xl tw-text-blue-100 tw-mb-12">
          Don’t leave your family’s tomorrow to chance. Get the right life cover
          today with Fintoo’s expert-backed guidance.
        </p>

        <div className="tw-bg-white tw-rounded-2xl tw-p-8 tw-text-gray-800">
          <form className="tw-space-y-6">
            <div className="tw-grid md:tw-grid-cols-2 tw-gap-6">
              <input
                type="text"
                placeholder="Full Name"
                className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500"
              />
            </div>

            <div className="tw-grid md:tw-grid-cols-2 tw-gap-6">
              <input
                type="tel"
                placeholder="Phone Number"
                className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500"
              />
              <input
                type="number"
                placeholder="Age"
                className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500"
              />
            </div>

            <div className="tw-grid md:tw-grid-cols-2 tw-gap-6">
              <input
                type="date"
                className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500"
              />
              <select className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500">
                <option>Select Gender</option>
                <option>Male</option>
                <option>Female</option>
              </select>
            </div>

            <div className="tw-grid md:tw-grid-cols-2 tw-gap-6">
              <select className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500">
                <option>Tobacco Usage</option>
                <option>Non-Tobacco User</option>
                <option>Tobacco User</option>
              </select>
              <select className="tw-w-full tw-p-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-blue-500">
                <option>Tobacco Usage</option>
                <option>Non-Tobacco User</option>
                <option>Tobacco User</option>
              </select>
            </div>

            <button
              type="submit"
              className="tw-w-full tw-bg-fintoo-orange tw-text-white tw-py-4 tw-rounded-lg tw-font-semibold tw-text-lg hover:tw-bg-fintoo-orange tw-transition-colors"
            >
              Show Me My Best Options
            </button>
          </form>
        </div>
      </div>

      {/* Background Grid */}
      <div className="tw-absolute tw-inset-0 tw-opacity-10">
        <svg width="100%" height="100%" viewBox="0 0 1000 1000">
          <defs>
            <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
              <path
                d="M 50 0 L 0 0 0 50"
                fill="none"
                stroke="white"
                strokeWidth="1"
              ></path>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)"></rect>
        </svg>
      </div>
    </section>
  );
}
